module.exports = __webpack_public_path__ + "media/site/images/icons/quality-yellow-icon-352534d8658758b667021b4c56c12b03.svg";